import type { SocialNetworksBlockProps } from "./types";
import PanelContainer from "../../lib/panel/panel-container";
import PanelBlockAlignment from "../../lib/panel/panel-block-alignment";
import PanelTranslationState from "../../lib/panel/panel-translation-state";
import { FloatingPanelSeparator } from "@babackapp/ui/components/floating-panel";
import { SocialNetworksEmailPanelStyle } from "./email-panel-style";


export function SocialNetworksEmailPanelRenderer(blockProps: SocialNetworksBlockProps) {

	return (
		<PanelContainer blockProps={blockProps}>
			<PanelBlockAlignment />
			<FloatingPanelSeparator />
			<SocialNetworksEmailPanelStyle />
      <PanelTranslationState mode="not-translatable" portal />
    </PanelContainer>
	);
}
